if (!customElements.get('guide-drawer')) {
  class GuideDrawer extends HTMLElement {
    constructor() {
      super();
      this.openDrawer = this.openDrawer.bind(this);
      this.openPopup = this.openPopup.bind(this);
      this.closePopup = this.closePopup.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[triger-guide-drawer-button]');
      this.buttonPopup = this.querySelector('[triger-guide-popup]');
      this.buttonClose = this.querySelectorAll('[close-guide-popup]');
      this.popupContainer = this.querySelector('[guide-popup]');
      this.getPortalElementId = this.getAttribute('target-portal-element') || null;

      this.button?.addEventListener('click', this.openDrawer);
      this.buttonPopup?.addEventListener('click', this.openPopup);
      this.buttonClose.forEach((button) => {
        button.addEventListener('click', this.closePopup);
      });

      this.wrapTables();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.openDrawer);
      this.buttonPopup?.removeEventListener('click', this.openPopup);
      this.buttonClose?.forEach((button) => {
        button.removeEventListener('click', this.closePopup);
      });
    }

    wrapTables() {
      this.querySelectorAll('table').forEach((table) => {
        if (table.parentElement?.classList.contains('scroll-table-wrapper')) return;

        const wrapper = document.createElement('div');
        wrapper.classList.add('scroll-table-wrapper');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    }

    closePopup() {
      this.popupContainer?.classList.remove('active');
    }

    openPopup() {
      this.popupContainer?.classList.add('active');
    }

    openDrawer() {
      HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.showDrawer, document, {
        drawerType: 'guide-drawer',
        portalDrawerTo: this.getPortalElementId,
        portalBackSectionId: this.id,
      });
    }
  }

  customElements.define('guide-drawer', GuideDrawer);
}
